import { lightMaterialTheme } from '@zz2/zz2-ui';

const materialTheme = lightMaterialTheme;

export default materialTheme;
